import BaseError from '@/objects/Exceptions/BaseError'

export default class HttpError extends BaseError {

  error = undefined

  constructor(message, error) {
    super({message}) // (1)
    this.name = "HttpError" // (2)
    this.error = error
  }

  static parseError (error) {
    let message = 'Something went wrong'
    console.error(error)
    if (error.data && error.data.message) {
      message = error.data.message
    }
    const result = new HttpError(message, error)
    return result
  }
}
